import React from "react";
import { useNavigate } from "react-router-dom";
import afacLogo from "../../assets/imgs/home/afac-logofull.png";
import banner from "../../assets/imgs/home/ishbilia new 1.jpg";
import ContactUs from "../../Components/ContactUs/ContactUs";
import MeetTeamComp from "../../Components/MeetTeam/MeetTeamComp";
import ServicesPage from "../Services/ServicesPage";
import "./Home.css";

const Home = () => {

  const navigate = useNavigate();

  return (
    <>
      <section className="hero-section container">
        <div className="hero-section-paragraphs-container">
          <div className="hero-section-big-title">
            A place of possibilities, a place for you to explore and get
            inspired.
          </div>
          <div className="hero-section-small-title">
            We have been here since 1980. We exist to empower our community and
            local artists by providing mediums and different
            artistic expressions, which support their innovation and
            creativity. 
          </div>
        </div>
        <div className="tb-hero-img tb-style1">
          <div className="tb-hero-img-box">
            <img src={banner} className="hero-image" alt="banner" />
          </div>
          <div className="tb-hero-img-box-circle"></div>
          <div className="tb-hero-img-box-square"></div>
        </div>
      </section>
      <section className="who-we-are-section" onClick={() => navigate("/about")}>
        <div className="who-we-are">
          <p className="who-we-are-word">WHO WE ARE ?</p>
          <button className="learn-more-button">Learn More</button>
        </div>
      </section>
      <ServicesPage />
      <section className="events-section" onClick={() => navigate("/events")}>
        <div className="events-upcoming">Upcoming Events</div>
        <div className="events-whats">What's coming to Ishbilia?</div>
      </section>
      <MeetTeamComp/>
      <hr />
      <ContactUs />
      <div className="afac-section">
      <img src={afacLogo} className="afac-logo"/>
      <p className="supported-statement">This website is supported by AFAC Arab Fund for Arts and Culture.</p>
      </div>
      <hr />
    </>
  );
};

export default Home;
